// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1FHVW","spin":"Loader_spin__3A6wl"};